import { buildApiUrl } from "./apiConfig";

export async function fetchCampaigns(fetchWithAuth) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to load campaigns.");
  }
  const res = await fetchWithAuth(buildApiUrl("/admin/campaigns"));
  if (!res.ok) {
    throw new Error("Kampagnen konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.campaigns ?? [];
}

export async function updateCampaignStatus(fetchWithAuth, campaignId, status) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to update campaigns.");
  }
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}/status`), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Kampagne konnte nicht aktualisiert werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.campaign;
}

export async function deleteCampaign(fetchWithAuth, campaignId) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to delete campaigns.");
  }
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}`), {
    method: "DELETE",
  });
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Kampagne konnte nicht gelöscht werden.");
  }
  return res.json().catch(() => ({}));
}

export async function fetchCampaignCars(fetchWithAuth, campaignId) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to load campaign vehicles.");
  }
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}/cars`));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Fahrzeuge konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.cars ?? [];
}

export async function fetchCampaignLocations(fetchWithAuth, campaignId) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to load campaign locations.");
  }
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}/locations`));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Gebiete konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.locations ?? [];
}

export async function downloadCampaignCreative(fetchWithAuth, campaignId) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to download creative assets.");
  }
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}/creative`));
  if (!res.ok) {
    let detail = "";
    try {
      const asJson = await res.json();
      detail = asJson?.detail || "";
    } catch {
      detail = await res.text().catch(() => "");
    }
    throw new Error(detail || "Creative konnte nicht heruntergeladen werden.");
  }
  return res.blob();
}

export async function updateCampaignCarStatus(fetchWithAuth, campaignId, assignmentId, status) {
  if (typeof fetchWithAuth !== "function") {
    throw new Error("fetchWithAuth is required to update campaign cars.");
  }
  const res = await fetchWithAuth(
    buildApiUrl(`/admin/campaigns/${campaignId}/cars/${assignmentId}/status`),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    }
  );
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Fahrzeugstatus konnte nicht aktualisiert werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.car;
}

export async function fetchCampaignRequests(fetchWithAuth, campaignId, status = null) {
  const suffix = status ? `?status=${encodeURIComponent(status)}` : "";
  const res = await fetchWithAuth(buildApiUrl(`/admin/campaigns/${campaignId}/requests${suffix}`));
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Anfragen konnten nicht geladen werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.requests ?? [];
}

export async function updateCampaignRequestStatus(fetchWithAuth, campaignId, requestId, status) {
  const res = await fetchWithAuth(
    buildApiUrl(`/admin/campaigns/${campaignId}/requests/${requestId}/status`),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    }
  );
  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload?.detail || "Anfrage konnte nicht aktualisiert werden.");
  }
  const payload = await res.json().catch(() => ({}));
  return payload?.request;
}
